export function getDownloads ({ state, commit }, { search , page = 1 }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/pagedownload', { params: { search, page } })
      .then((response) => {
        commit('setDownloads', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getDownload ({ state, commit }, dId) {
  return new Promise((resolve, reject) => {
    if (dId) {
      axiosInstance.get('/v1/pagedownload/' + dId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No download id'))
    }
  })
}

export function getCreateDownload ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/pagedownload/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createDownload ({ state, commit }, newdownload) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/pagedownload', newdownload)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditDownload ({ state, commit }, dId) {
  return new Promise((resolve, reject) => {
    if (dId) {
      axiosInstance.get('/v1/pagedownload/' + dId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No download id'))
    }
  })
}

export function editDownload ({ state, commit }, { id, item }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/pagedownload/' + id, { item })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No download id'))
    }
  })
}

export function savePositions ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/pagedownload/savePositions', { downloads: state.downloads })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function deleteDownload ({ state, commit }, dId) {
  return new Promise((resolve, reject) => {
    if (dId) {
      axiosInstance.delete('/v1/pagedownload/' + dId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No download id'))
    }
  })
}

export function uploadIcon ({ state, commit }, formData) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/pagedownload/upload/0', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function uploadFile ({ state, commit }, formData) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/pagedownload/upload/1', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
